import React from 'react';

const FloatingWhatsApp = () => {
  return (
    <a 
      href="https://wa.me/213770281922" 
      target="_blank" 
      rel="noreferrer"
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        backgroundColor: '#25D366',
        color: 'white',
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '30px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
        zIndex: 9999,
        textDecoration: 'none',
        transition: 'transform 0.3s'
      }}
      onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
      onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
    >
      📞
    </a>
  );
};

export default FloatingWhatsApp;